export const constants = {
  SET: 'AGENDA_FILTERS.SET',
  SET_MULTIPLE: 'AGENDA_FILTERS.SET_MULTIPLE',
};

export const initialState = {
  order: true
};

export function reducer(state = initialState, { payload, type }) {
  switch (type) {
    case constants.SET:
      return {
        ...state,
        [payload.key]: payload.value
      };
    case constants.SET_MULTIPLE: {
      return {
        ...state,
        ...payload
      }
    }
    default:
      return state;
  }
}

export const actions = {
  setFilter: (key, value) => {
    return {
      type: constants.SET,
      payload: { key, value }
    };
  },
  setFilters: (payload) => {
    return {
      type: constants.SET_MULTIPLE,
      payload
    };
  }
}



// WEBPACK FOOTER //
// ./src/redux/agendaFilters.js